import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { CityModel } from 'Pages/referenceBooks'

export type CitiesState = {
	data: ResponseCatalog<CityModel>
	params: RequestParams
	formState: {
		open: boolean
		item?: CityModel
	}
}

const initialState: CitiesState = {
	data: new ResponseCatalog<CityModel>(),
	params: new RequestParams(),
	formState: {
		open: false,
		item: undefined,
	},
}

export namespace CitiesNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: () => {}
	}>
	export type GetAllSuccess = PayloadAction<{ data: ResponseCatalog<CityModel> }>

	export type SetRequestParams = PayloadAction<{ params: RequestParams }>
	export type OpenForm = PayloadAction<{ item?: CityModel }>

	export type CreateOne = PayloadAction<{ item: Omit<CityModel, 'id'> }>
	export type UpdateOne = PayloadAction<{ item: CityModel }>
	export type DeleteOne = PayloadAction<{ id: number }>
	export type RestoreOne = PayloadAction<{ id: number }>
	export type ClearAll = PayloadAction
}

export const citiesSlice = createSlice({
	name: 'cities',
	initialState,
	reducers: {
		getAll: (state, action: CitiesNS.GetAll) => {},
		getAllSuccess: (state, action: CitiesNS.GetAllSuccess) => {
			state.data = action.payload.data
		},

		setRequestParams: (state, action: CitiesNS.SetRequestParams) => {
			state.params = action.payload.params
		},

		resetState: (state) => {
			return initialState
		},

		openForm: (state, action: CitiesNS.OpenForm) => {
			state.formState = {
				open: true,
				item: action.payload.item,
			}
		},
		closeForm: (state) => {
			state.formState = initialState.formState
		},

		createOne: (state, action: CitiesNS.CreateOne) => {},
		updateOne: (state, action: CitiesNS.UpdateOne) => {},
		deleteOne: (state, action: CitiesNS.DeleteOne) => {},
		restoreOne: (state, action: CitiesNS.RestoreOne) => {},
		clearAll: (state, action: CitiesNS.ClearAll) => {
			state.data = new ResponseCatalog<CityModel>()
			state.params = new RequestParams()
		},
	},
})
